import { defineStore } from 'pinia'
import { computed,ref } from 'vue'

export type TokenValidationState = {
  tokenValid: boolean
  apiRequestCount: number
}


export const useTokenValidationStore = defineStore('tokenValidation', () => {
  // State
  const tokenValid = ref(true)
  const apiRequestCount = ref(0)

  // Actions
  function setTokenValid(valid: boolean) {
    tokenValid.value = valid
  }

  function setApiRequestCount(count: number) {
    apiRequestCount.value = count
  }

  function incrementApiRequestCount() {
    apiRequestCount.value++
  }

  // Getter
  const getTokenValid = computed(() => tokenValid.value)
  const getApiRequestCount = computed(() => apiRequestCount.value)

  return {
    tokenValid,
    apiRequestCount,
    setTokenValid,
    setApiRequestCount,
    incrementApiRequestCount,
    getTokenValid,
    getApiRequestCount
  }
})